<mat-drawer-container class="sidenav-container">
    <mat-drawer id="snav-mobile" #snavMobile mode="over" position="end" class="sidenav">
        <app-sitenav-content></app-sitenav-content>
    </mat-drawer>
    <mat-drawer id="snav-desktop" #snavDesktop  opened mode="side" position="start" class="sidenav">
        <app-sitenav-content></app-sitenav-content>
    </mat-drawer>
    <mat-drawer-content>
        <router-outlet />
    </mat-drawer-content>
</mat-drawer-container>
